import { render, staticRenderFns } from "./ecommerce.vue?vue&type=template&id=7dc36392&"
import script from "./ecommerce.vue?vue&type=script&lang=ts&"
export * from "./ecommerce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports